export default __webpack_public_path__ + "static/media/UniversLTStd-Obl.89aefc53.otf";